/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
function r(r, e, n) {
  if (!e || !r || !r.map) return;
  var a = r.map,
      d = a.layers.find(function (r) {
    return r === e;
  });
  d || a.add(e, n), null != n && a.layers.reorder(d, n);
}

export { r as addUniqueLayer };